import { defaultNavigatorLanguage } from "../../constants";

export function getNavigatorLanguage() {
  const languages = navigator.languages || [];
  const language = languages[0] || navigator.language || defaultNavigatorLanguage;

  return language.split('-')[0];
}
